// PawGlow — scripts propios (vanilla, sin librerías externas)

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var animate = function (el) {
    var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
    var suffix = el.getAttribute('data-mt-sufijo') || '';
    var duration = 1400;
    var start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased * 10) / 10;
      el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-mt-comparador]');
  wraps.forEach(function (wrap) {
    var slider = wrap.querySelector('[data-mt-comparador-slider]');
    var after = wrap.querySelector('[data-mt-comparador-after]');
    var handle = wrap.querySelector('[data-mt-comparador-handle]');
    if (!slider || !after || !handle) return;
    var setPos = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    };
    slider.addEventListener('input', function () { setPos(Number(slider.value)); });
    setPos(Number(slider.value || 50));
  });
}

function initGaleriaProducto() {
  var wraps = document.querySelectorAll('[data-mt-galeria]');
  wraps.forEach(function (wrap) {
    var main = wrap.querySelector('[data-mt-galeria-principal]');
    var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) main.setAttribute('src', src);
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
        thumb.classList.add('mt-thumb-activa');
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    var select = form.querySelector('[data-mt-variante-select]');
    if (!dataEl || !select) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioComparadoEl = form.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    var textoDisponible = botonEl ? botonEl.getAttribute('data-texto-disponible') : '';
    var textoAgotado = botonEl ? botonEl.getAttribute('data-texto-agotado') : '';

    var actualizar = function () {
      var id = select.value;
      var variante = variantes.find(function (v) { return String(v.id) === String(id); });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;
      if (precioComparadoEl) {
        if (variante.compare_at_price_formatted) {
          precioComparadoEl.textContent = variante.compare_at_price_formatted;
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        botonEl.disabled = !variante.available;
        botonEl.textContent = variante.available ? textoDisponible : textoAgotado;
      }
    };
    select.addEventListener('change', actualizar);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContador();
  initComparador();
  initGaleriaProducto();
  initVariantes();
});
